module.exports = __webpack_public_path__ + "static/media/talance.5e8732cd.png";